<input type="radio" [id]="id" [value]="value" [formControlName]="controlName">
<label [for]="id">
    <span class="circle"></span>
    <span class="text">{{ label }}</span>
</label>
